(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gsap-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGSAPBanner(scope) {
      var banners = (scope || document).querySelectorAll('[data-gsap-banner]');
      if (!banners.length) return;
      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

      gsap.registerPlugin(ScrollTrigger);

      banners.forEach(function (banner) {
        var image = banner.querySelector('[data-gsap-banner-image]');
        var content = banner.querySelector('[data-gsap-banner-content]');
        if (!image || !content) return;

        var media = banner.querySelector('[data-gsap-banner-media]');

        // Initial state (match CSS so JS takeover looks consistent)
        gsap.set(content, { opacity: 0.18, y: 24 });
        gsap.set(image, {
          filter: 'blur(24px) brightness(0.55)',
          scale: 1.12,
        });

        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: banner,
            start: 'top top',
            end: '+=100%',
            pin: true,
            pinSpacing: true,
            scrub: 1,
          },
        });

        // 1) Text brightens and lifts slightly (first 55%)
        tl.to(content, {
          opacity: 1,
          y: 0,
          ease: 'none',
        }, 0);

        // 2) Then image de-blurs + brightens (45% to end)
        tl.to(image, {
          filter: 'blur(0px) brightness(1)',
          scale: 1,
          ease: 'none',
        }, 0.45);
      });
    }

    function loadAndInit() {
      var existing = document.getElementById('gsap-banner-gsap');
      if (existing) {
        if (existing.dataset.loaded === 'true') initGSAPBanner(document);
        else existing.addEventListener('load', function () { initGSAPBanner(document); });
        return;
      }

      var s1 = document.createElement('script');
      s1.id = 'gsap-banner-gsap';
      s1.src = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';
      s1.async = true;

      var s2 = document.createElement('script');
      s2.src = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js';
      s2.async = true;

      s1.addEventListener('load', function () {
        s2.addEventListener('load', function () { initGSAPBanner(document); });
        document.body.appendChild(s2);
      });

      document.body.appendChild(s1);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadAndInit);
    } else {
      loadAndInit();
    }

    // Shopify theme editor: re-init after section changes
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) {
        initGSAPBanner(e.target);
      });
      document.addEventListener('shopify:section:select', function (e) {
        // No real scroll in editor: show final state for preview
        var banner = e.target.querySelector('[data-gsap-banner]');
        if (!banner || typeof gsap === 'undefined') return;
        var content = banner.querySelector('[data-gsap-banner-content]');
        var image = banner.querySelector('[data-gsap-banner-image]');
        if (content) gsap.set(content, { opacity: 1, y: 0 });
        if (image) gsap.set(image, { filter: 'blur(0px) brightness(1)', scale: 1 });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsap-scroll-steps"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSteps(scope) {
      var roots = (scope || document).querySelectorAll('[data-gsap-steps]');
      if (!roots.length) return;
      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

      gsap.registerPlugin(ScrollTrigger);

      roots.forEach(function (root) {
        var panels = root.querySelectorAll('[data-gsap-steps-panel]');
        var count = parseInt(root.getAttribute('data-count') || panels.length, 10);
        if (count <= 1) return;

        // Initial: only first block visible
        panels.forEach(function (p, i) {
          gsap.set(p, { opacity: i === 0 ? 1 : 0, visibility: i === 0 ? 'visible' : 'hidden', y: i === 0 ? 0 : 40 });
        });

        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: root,
            start: 'top top',
            end: '+=' + (count * 100) + '%',
            pin: true,
            pinSpacing: true,
            scrub: 1,
          },
        });

        // Each block takes one segment: previous fades out/down, next fades in/up
        var seg = 1 / count;
        for (var i = 1; i < count; i++) {
          var at = i * seg;
          var prev = panels[i - 1];
          var next = panels[i];
          tl.to(prev, { opacity: 0, y: -40, visibility: 'hidden', duration: seg, ease: 'none' }, at)
            .fromTo(next, { opacity: 0, y: 40, visibility: 'visible' },
                     { opacity: 1, y: 0, duration: seg, ease: 'none' }, at);
        }
      });
    }

    function loadAndInit() {
      var id = 'gsap-steps-gsap';
      var existing = document.getElementById(id);
      if (existing) {
        if (existing.dataset.loaded === 'true') initSteps(document);
        else existing.addEventListener('load', function () { initSteps(document); });
        return;
      }
      var s1 = document.createElement('script');
      s1.id = id;
      s1.src = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';
      s1.async = true;
      var s2 = document.createElement('script');
      s2.src = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js';
      s2.async = true;
      s1.addEventListener('load', function () {
        s2.addEventListener('load', function () { initSteps(document); });
        document.body.appendChild(s2);
      });
      document.body.appendChild(s1);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadAndInit);
    } else {
      loadAndInit();
    }

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) { initSteps(e.target); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nvx-why-choose"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRoot(root) {
      var el = root.querySelector('[data-spd-swiper]');
      var next = root.querySelector('[data-spd-next]');
      var prev = root.querySelector('[data-spd-prev]');
      if (!el || root.dataset.spdInit) return;
      root.dataset.spdInit = '1';

      var swiper = null;

      function setup() {
        var isDesktop = window.matchMedia('(min-width: 768px)').matches;
        if (isDesktop && window.Swiper) {
          if (!swiper) {
            swiper = new Swiper(el, {
              slidesPerView: 'auto',
              freeMode: true,
              grabCursor: true,
              slidesOffsetAfter: 24,
              navigation: {
                nextEl: next,
                prevEl: prev,
              },
            });
          }
        } else if (swiper) {
          swiper.destroy(true, true);
          swiper = null;
        }
      }

      function onResize() {
        window.clearTimeout(root._spdResizeTimer);
        root._spdResizeTimer = window.setTimeout(setup, 150);
      }

      var tries = 0;
      var timer = window.setInterval(function () {
        tries++;
        if (window.Swiper || tries > 50) {
          window.clearInterval(timer);
          setup();
          window.addEventListener('resize', onResize);
        }
      }, 100);
    }

    function initAll() {
      document.querySelectorAll('[data-spd]').forEach(initRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-spd]');
      if (root) initRoot(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ROOT = '[data-rec]';
    var ready;

    function findRoot(target) {
      if (!target) return null;
      if (target.matches && target.matches(ROOT)) return target;
      return target.querySelector ? target.querySelector(ROOT) : null;
    }

    function whenSwiperReady() {
      if (window.Swiper) return Promise.resolve();
      if (ready) return ready;

      ready = new Promise(function (resolve) {
        var settled = false;
        function finish() {
          if (settled) return;
          settled = true;
          resolve();
        }

        var script = document.querySelector('script[src*="swiper-bundle"]');
        if (script) script.addEventListener('load', finish, { once: true });

        var started = Date.now();
        (function tick() {
          if (window.Swiper || Date.now() - started > 4000) {
            finish();
            return;
          }
          requestAnimationFrame(tick);
        })();
      });

      return ready;
    }

    function createSwiper(root) {
      var el = root.querySelector('[data-rec-swiper]');
      if (!el || !window.Swiper || el.swiper) return;

      var next = root.querySelector('[data-rec-next]');
      var prev = root.querySelector('[data-rec-prev]');

      new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        freeMode: true,
        grabCursor: true,
        watchOverflow: true,
        slidesOffsetAfter: 24,
        observer: true,
        observeParents: true,
        navigation: next && prev ? { nextEl: next, prevEl: prev } : undefined,
        breakpoints: {
          0: { spaceBetween: 12, slidesOffsetAfter: 16 },
          768: { spaceBetween: 16, slidesOffsetAfter: 24 }
        }
      });
    }

    function destroySwiper(root) {
      var el = root && root.querySelector('[data-rec-swiper]');
      if (el && el.swiper) el.swiper.destroy(true, true);
    }

    function initRoot(root) {
      if (!root) return;
      whenSwiperReady().then(function () {
        if (!root.isConnected) return;
        createSwiper(root);
      });
    }

    function initAll() {
      document.querySelectorAll(ROOT).forEach(initRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initRoot(findRoot(e.target));
    });

    document.addEventListener('shopify:section:unload', function (e) {
      destroySwiper(findRoot(e.target));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
